import React from 'react';
import { Tabs } from 'antd';
import { KeywordTrendPivotTab } from '../tabs/KeywordTrendPivot';
import { PriceCVRInsightTab } from '../tabs/PriceCVRInsight';
import {
    AdvantageKeywordsTab,
    MarketOverviewTab,
    OpportunityKeywordsTab,
} from '../index';
import type {
    AdvantageKeywordsResult,
    MarketOverview,
    OpportunityKeywordsResult,
} from '../../../types';

interface SearchPerformanceTabsProps {
    keywordPivotData: any;
    spLoading: boolean;
    spSelectedPeriodId: number | null;
    advantageData: AdvantageKeywordsResult | null;
    marketOverview: MarketOverview | null;
    opportunityData: OpportunityKeywordsResult | null;
    onTabChange: (key: string) => void;
}

export const SearchPerformanceTabs: React.FC<SearchPerformanceTabsProps> = ({
    keywordPivotData,
    spLoading,
    spSelectedPeriodId,
    advantageData,
    marketOverview,
    opportunityData,
    onTabChange,
}) => {
    return (
        <Tabs
            defaultActiveKey="sp-pivot"
            onChange={onTabChange}
            items={[
                {
                    key: 'sp-pivot',
                    label: '📊 关键词趋势透视',
                    children: <KeywordTrendPivotTab data={keywordPivotData} loading={spLoading} />,
                },
                {
                    key: 'sp-price-cvr',
                    label: '💰 价格-转化率洞察',
                    children: (
                        <PriceCVRInsightTab periodId={spSelectedPeriodId} />
                    ),
                },
                {
                    key: 'sp-advantage',
                    label: '优势关键词',
                    children: (
                        <AdvantageKeywordsTab data={advantageData} loading={spLoading} />
                    ),
                },
                {
                    key: 'sp-overview',
                    label: '大盘概况',
                    children: (
                        <MarketOverviewTab data={marketOverview} loading={spLoading} />
                    ),
                },
                {
                    key: 'sp-opportunity',
                    label: '机会词挖掘',
                    children: (
                        <OpportunityKeywordsTab data={opportunityData} loading={spLoading} />
                    ),
                },
            ]}
        />
    );
};
